export const createGallery = (item) => {
  const galleryItem = document.createElement('li');
  galleryItem.classList.add('glide__slide');
  const galleryImage = document.createElement('img');
  galleryImage.setAttribute('data-src', item)
  galleryImage.classList.add('defer', 'img-fluid')
  galleryItem.appendChild(galleryImage)

  return galleryItem;
}